import React from "react";
import { useI18n } from "@/i18n";

export const Kicker = ({ children, className = "" }) => (
  <p className={`cs-kicker ${className}`}>{children}</p>
);

export const PageHero = ({ kicker, title, lead, image }) => (
  <header className="relative border-b border-border bg-secondary/40">
    <div className="cs-container grid grid-cols-1 gap-10 py-20 md:grid-cols-12 md:py-28">
      <div className="md:col-span-7 cs-rise">
        <Kicker>{kicker}</Kicker>
        <h1 className="mt-6 font-display text-4xl font-light leading-[1.05] sm:text-5xl lg:text-6xl">{title}</h1>
        {lead && <p className="mt-8 max-w-2xl text-base text-muted-foreground sm:text-lg">{lead}</p>}
      </div>
      {image && (
        <div className="md:col-span-5">
          <div className="h-56 w-full overflow-hidden border border-border md:h-full md:min-h-[280px]">
            <img src={image} alt="" className="h-full w-full object-cover" loading="lazy" />
          </div>
        </div>
      )}
    </div>
  </header>
);

export const Section = ({ children, className = "", ...rest }) => (
  <section className={`py-20 md:py-28 ${className}`} {...rest}>
    <div className="cs-container">{children}</div>
  </section>
);

export const CardGrid = ({ items, testIdPrefix = "card", cols = 3 }) => (
  <div className={`mt-12 grid grid-cols-1 gap-6 ${cols === 2 ? "md:grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
    {items.map((item, index) => (
      <article
        key={item.title}
        data-testid={`${testIdPrefix}-${index}`}
        className="group border border-border bg-surface p-8 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-accent/60 hover:shadow-md"
      >
        <span className="font-display text-2xl text-accent">{String(index + 1).padStart(2, "0")}</span>
        <h3 className="mt-4 font-display text-2xl font-medium">{item.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
      </article>
    ))}
  </div>
);

export const VerticalList = ({ testId = "vertical-list" }) => {
  const { t } = useI18n();
  const verticals = t("verticals");
  return (
    <ul data-testid={testId} className="mt-10 divide-y divide-border border-y border-border">
      {Object.entries(verticals).map(([key, label], index) => (
        <li key={key} className="flex items-baseline gap-6 py-5">
          <span className="cs-kicker w-8 shrink-0">{String(index + 1).padStart(2, "0")}</span>
          <span className="font-display text-xl sm:text-2xl">{label}</span>
        </li>
      ))}
    </ul>
  );
};
